export enum InputType {
  Address,
  Checkbox,
  ColorPicker,
  DateRange,
  Datepicker,
  Email,
  File,
  Image,
  MultiSearch,
  MultiSelect,
  Number,
  Select,
  Tel,
  Text,
  Textarea,
  Password,
  Toggle,
  Radio,
  Time
}
